/* Definitive PDP only: retain store-midnight timing, update changed digits, pause in hidden tabs. */
(() => {
  "use strict";
  if (!customElements.get("gns-daily-clock")) {
    class DailyClock extends HTMLElement {
      connectedCallback() {
        if (this.timer) return;
        this.deadlines = (this.dataset.midnights || "").split(",").map(Number).filter(Number.isFinite);
        const offset = /^([+-])(\d{2}):?(\d{2})$/.exec(this.dataset.shopOffset || "+00:00");
        this.offset = offset ? (Number(offset[2]) * 3600 + Number(offset[3]) * 60) * (offset[1] === "-" ? -1 : 1) : 0;
        this.nodes = ["hours", "minutes", "seconds"].map((unit) => this.querySelector(`[data-gns-${unit}]`));
        this.tick = () => {
          clearTimeout(this.timer);
          if (document.hidden) return;
          const now = Date.now() / 1000;
          const deadline = this.deadlines.find((value) => value > now) || (Math.floor((now + this.offset) / 86400) + 1) * 86400 - this.offset;
          const remaining = Math.max(0, Math.ceil(deadline - now));
          const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
          this.nodes.forEach((node, index) => {
            const text = String(values[index]).padStart(2, "0");
            if (node && node.textContent !== text) node.textContent = text;
          });
          this.setAttribute("aria-label", `${values[0]} hours, ${values[1]} minutes and ${values[2]} seconds remaining today`);
          this.timer = setTimeout(this.tick, 1000 - Date.now() % 1000);
        };
        this.controller = new AbortController();
        document.addEventListener("visibilitychange", this.tick, { signal: this.controller.signal });
        this.tick();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.timer = null;
        this.controller?.abort();
      }
    }
    customElements.define("gns-daily-clock", DailyClock);
  }
  if (!customElements.get("gns-announcement")) {
    customElements.define("gns-announcement", class extends HTMLElement {
      connectedCallback() {
        let previousHeight;
        this.observer = new ResizeObserver(([entry]) => {
          const height = entry.borderBoxSize?.[0]?.blockSize ?? entry.target.getBoundingClientRect().height;
          if (height === previousHeight) return;
          previousHeight = height;
          document.documentElement.style.setProperty("--gns-announcement-height", `${height}px`);
        });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
})();
